module.exports = __webpack_public_path__ + "src/img/checker-round.1acb5ac1.svg";